// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__RMyF1","title":"ClientInsurance_title__30mHV","itemText":"ClientInsurance_itemText__2kYt9"};